import { Fragment } from 'react';
import { View } from 'react-native';
import StyleSheet from 'react-native-media-query';
import { Divider, useTheme } from '@ui-kitten/components';
import lodashIsEmpty from 'lodash/isEmpty';

import EmptyData from '../../Components/EmptyData';
import ResponsiveText from '../../Components/ResponsiveText';
import ScreenWrapper from '../../Components/ScreenWrapper';
import themeStyle from '../../Theme/styles';
import breakpoints from '../../Theme/styles/breakpoints';

import Header from './Header';
import useMyReservations from './index.controller';
import ReservationCard from './ReservationCard';

const MyReservationsWeb = () => {
  const theme = useTheme();
  const {
    activeBookings,
    pastBookings,
    onCardPress,
    onReachedEnd,
    setKeyword,
    setType,
  } = useMyReservations();

  return (
    <ScreenWrapper onEndReached={onReachedEnd} onEndReachedThreshold={0.5}>
      <View style={[themeStyle.flex1, themeStyle.flexDirectionRowCenterCenter]}>
        <View
          dataSet={{ media: ids.contentContainer }}
          style={[themeStyle.flex1, styles.contentContainer]}
        >
          <View
            dataSet={{ media: ids.headerContainer }}
            style={styles.headerContainer}
          >
            <Header onSearch={setKeyword} onTypeChange={setType} />
          </View>
          <Divider style={themeStyle.sectionSeparator} />
          {/* Active Bookings */}
          {!lodashIsEmpty(activeBookings) && (
            <View style={themeStyle.spacingTopMedium}>
              <ResponsiveText category="s1" style={themeStyle.bold}>
                Active
              </ResponsiveText>
              <View style={styles.itemsContainer}>
                {activeBookings.map((data, i) => (
                  <Fragment key={i}>
                    <View style={themeStyle.pageVerticalSpacingMedium}>
                      <ReservationCard {...data} onCardPress={onCardPress} />
                    </View>
                    {i !== activeBookings.length - 1 && (
                      <Divider style={themeStyle.divider} />
                    )}
                  </Fragment>
                ))}
              </View>
            </View>
          )}
          {/* Past Bookings */}
          {lodashIsEmpty(activeBookings) && lodashIsEmpty(pastBookings) ? (
            <View
              style={[
                themeStyle.flex1,
                themeStyle.pageVerticalSpacing,
                themeStyle.pageHorizontalSpacing,
              ]}
            >
              <EmptyData
                title="No Reservations Yet"
                subtitle="Looks like you haven't made any reservations. Once you do, they'll show up here."
                type="filter"
                fill={theme['color-info-500']}
              />
            </View>
          ) : (
            <Fragment>
              {!lodashIsEmpty(pastBookings) && (
                <View style={themeStyle.pageVerticalSpacingMedium}>
                  <ResponsiveText
                    category="s1"
                    status="primary"
                    style={themeStyle.bold}
                  >
                    Past
                  </ResponsiveText>
                </View>
              )}
              <View style={styles.itemsContainer}>
                {pastBookings.map((data, i) => (
                  <Fragment key={i}>
                    <View style={themeStyle.pageVerticalSpacingMedium}>
                      <ReservationCard {...data} onCardPress={onCardPress} />
                    </View>
                    {i !== pastBookings.length - 1 && (
                      <Divider style={themeStyle.divider} />
                    )}
                  </Fragment>
                ))}
              </View>
            </Fragment>
          )}
        </View>
      </View>
    </ScreenWrapper>
  );
};

const { ids, styles } = StyleSheet.create({
  contentContainer: {
    ...themeStyle.spacingBottom,
    maxWidth: 940, // same in orders page
    width: '100%',
    [`@media ${breakpoints.xl}`]: {
      ...themeStyle.pageVerticalSpacing,
      marginBottom: 0,
    },
  },
  headerContainer: {
    ...themeStyle.spacingBottomMedium,
    [`@media ${breakpoints.md}`]: themeStyle.spacingBottom,
  },
  itemsContainer: {},
});

export default MyReservationsWeb;
